export default {
  switchAccount: "Cambiar cuenta",
  login: "Iniciar sesión",
  loginFirst: "Por favor, inicie sesión primero.",
  start: "Iniciar",
  hasHistory: "Ya has respondido algunas de las preguntas.",
  loadHistory: "¿Quieres continuar?",
  cancel: "No",
  confirm: "Confirmar",
  contact:
    "¡Deja tus datos de contacto para tener la oportunidad de ganar premios extras!",
  completed: "¡Has completado la encuesta!",
  leaveMessage:
    "¡Deja tus datos de contacto para tener la oportunidad de ganar premios extras!",
  enterEmail: "Correo:",
  enterPhone: "Teléfono:",
  submit: "Enviar",
  leave: "Salir",
  submitted: "Enviado",
  thanks: "¡Gracias!",
  opinion: "¿Cuál es tu opinión?",
  prev: "Anterior",
  next: "Siguiente",
  unlikely: "Muy poco probable",
  likely: "Muy probable",
  claimYourRewards: "Puedes reclamar tus recompensas.",
  rewardSent: "Recompensas enviadas.",
  checkInGame: "Ve al juego para reclamarlas.",
  copy: "Copiar",
  copied: "¡Copiado!",
  selectTips: "Selecciona la mejor respuesta.",
  multipleTips: "Puedes seleccionar varias respuestas.",
  leastChoose: "Selecciona hasta xxx respuestas",
  maxChoose: "Selecciona al menos xxx respuestas.",
  mustAnswer: "Primero debes responder la pregunta.",
  mustWrite: "Escribe algo.",
  checkEmail: "Ingresa un correo electrónico válido.",
  checkPhone: "Ingresa un número telefónico válido.",
  isAnswer: "Ya has terminado la encuesta.",
  unStart: "Evento no disponible",
  end: "El evento ha terminado",
  server: "Selecciona tu servidor",
  role: "Selecciona tu personaje",
  common: "El sistema está ocupado. Intenta nuevamente más tarde.",
  title: "Cuestionario",
  titleAward: "Encuesta",
  leastWord: "Ingresa al menos xxx caracteres.",
  maxWord: "¡Límite de caracteres (xxx) superado!",
  singleChoose: "Respuesta única",
  multiChoose: "Varias respuestas",
  matrix: "Pregunta matriz",
  score: "Clasificación",
  textLimit: "(xx-yyy personajes)",
  coverGiftTitle: "Completa la encuesta para ganar un regalo",
  "-20001": "No iniciado sesión",
  "-20002": "Faltan parámetros requeridos",
  "-20003": "Cuestionario no encontrado",
  "-20004": "Configuración del cuestionario en progreso",
  "-20005": "Cuestionario detenido",
  "-20006": "Evento del cuestionario no iniciado",
  "-20007": "Evento del cuestionario finalizado",
  "-20008": "Ya respondido",
  "-20010": "Distribución de recompensas fallida",
  "-20011": "Recompensa ya distribuida para este cuestionario",
  "-20012": "Aún no respondido",
  "-20016": "ID de juego no válido",
};
